import React from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';

export const MapProvider = ({ children }) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  
  if (!apiKey) {
    console.error('Google Maps API key is missing');
    return (
      <div className="flex items-center justify-center h-full bg-gray-100 text-gray-500">
        <div className="text-center p-4">
          <p className="font-medium">Google Maps no configurado</p>
          <p className="text-sm">Contacta al administrador</p>
        </div>
      </div>
    );
  }

  return (
    <APIProvider 
      apiKey={apiKey}
      libraries={['geometry', 'places']}
      onLoad={() => console.log('Maps API loaded successfully')}
    >
      {children}
    </APIProvider>
  );
};